export enum UnitConfigType {
    SERIAL = 'SERIAL',
	MODBUS = 'MODBUS',
    TCPIP = 'TCPIP',
    TCPIPSERVER = 'TCPIPSERVER'
}
